import { azureLoginUri } from "~/config/apiConfig";
import { ERROR_MESSAGES } from "./errorMessages";

export function ErrorBoundary(statusCode: number): string {
  if (statusCode === 401) {
    window.location.href = azureLoginUri;
    return ERROR_MESSAGES[statusCode] || `認証に失敗しました(errorCode: ${statusCode})`;
  } else if (statusCode >= 500) {
    window.location.href = "/server-error.html";
    return ERROR_MESSAGES[statusCode] || `サーバーエラーが発生しました(errorCode: ${statusCode})`;
  } else {
    // エラーメッセージを返す
    return ERROR_MESSAGES[statusCode] || `エラーが発生しました(errorCode: ${statusCode})`;
  }
}
